import { PaymentProviders } from './PaymentProviders';

export abstract class PaymentProvider {
    protected constructor(public type: PaymentProviders) {
    }
}
